


















































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
const getUrl = require('bmh/url-with-param');
const WARE_TYPE_LIST = [
  { value: 0, label: '全部' },
  { value: 1, label: '实物' },
  {
    value: 2,
    label: '虚拟',
    children: [
      { value: 0, label: '无' },
      { value: 1, label: '兑换码' },
    ],
  },
];
const { VUE_APP_FCAPI: FCAPI, VUE_APP_API } = process.env;
const numeral = require('numeral');
const API = {
  add_set_meal: `${FCAPI}/shang/ruan/suit`,
  query: `${VUE_APP_API}/qy/ware/list/query`,
  category_list: `${FCAPI}/shang/ware/category`,
  get_ware: `${FCAPI}/shang/ruan/suit/ware`,
};
const MAX_LENGTH = 20;
const TAG_MAX_LENGTH = 4;
const UPLOAD_DIR = {
  list_image: 'list_image',
  index_image: 'index_image',
  detail: 'detail',
};

const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

// interface 接口定义 用来检测数据类型
interface Form {
  name: string;
  city: string;
  list_img_url: string;
  unit_img_url: [];
}

// 必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

// 必填项提示信息列表
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => !!value,
      message: '请输入名称',
    },
    {
      field: 'price',
      validate: (value: string): boolean => !!value,
      message: '请输入价格',
    },
    {
      field: 'list_image',
      validate: (value: string): boolean => !!value,
      message: '请选择列表图',
    },
    {
      field: 'index_image',
      validate: (value: string): boolean => !!value,
      message: '请选择首图',
    },
    {
      field: 'detail_image_list',
      validate: (value: string): boolean => value.length > 0,
      message: '请选择详情图',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

function getWareData(remote?: any) {
  remote = remote || {};
  return {
    current_page: remote.current_page || 0,
    data: remote.data || [],
    last_page: remote.last_page || 0,
    per_page: remote.per_page || 0,
    total: remote.total || 0,
  };
}

function initFormValue(remote?: any) {
  remote = remote || {};
  return {
    name: remote.name || '',
    price: remote.price ? (remote.price / 100).toFixed(2) : '',
    tag_name: remote.tag_name || '',
    tag: remote.tag || [],
    area: remote.area || '',
    set_meal: remote.set_meal || '',
    list_image: remote.list_image || '',
    index_image: remote.index_image || '',
    detail_image_list: remote.detail_image_list || [],
    description: remote.description || '',
  };
}
@Component({
  components: {
    MultipleImageUpload,
    SingleImageUpload,
  },
})
export default class AddSetMeal extends Vue {
  is_show_add_ware_modal: boolean = false;
  category_list: any = [];
  edit_index: number = -1;
  edit_field: string = '';
  form_layout: any = {
    labelCol: { span: 2 },
    wrapperCol: { span: 15 },
  };
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  form: any = initFormValue();
  is_show_image_modal: boolean = false;
  is_edit: boolean = false;
  modal_image_src: string = '';
  selected_row_keys: any = [];
  selected_ware: any = [];
  loaded_data: any = [];
  old_value: number = 0;
  delete_id_arr: any = [];
  filter_form: any = {
    name: '',
    type: [],
    category: [],
  };
  page: number = 1;
  ware_data: any = getWareData();

  get uploadDir() {
    return UPLOAD_DIR;
  }
  get maxLength() {
    return MAX_LENGTH;
  }
  get tagMaxLength() {
    return TAG_MAX_LENGTH;
  }
  get wareTypeList() {
    return WARE_TYPE_LIST;
  }
  is_loading: boolean = false;

  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }
  handlePreview(imageUrl: string) {
    this.modal_image_src = imageUrl;
    this.is_show_image_modal = true;
  }

  categoryFormat(first_id?: number | undefined, second_id?: number): string {
    if (!arguments.length) {
      return '';
    }
    const category_item: any = this.category_list.filter((item: any) => item.id === first_id)[0];
    let category_name: string = '';
    category_name = !second_id
      ? category_item.name
      : `${category_item.name}/${category_item.sub_category.filter((item: any) => item.id === second_id)[0].name}`;
    return category_name;
  }

  // 判断是否有必选项没有填
  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid ? '' : this.validatorMap[field].message;
    return is_valid;
  }

  listBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  indexBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  detailBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  onSelectChange(selectedRowKeys: any) {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.selected_row_keys = selectedRowKeys;
  }

  // 删除商品
  deleteWare(item: any) {
    this.delete_id_arr.push(item.bind_id);
    this.selected_ware.forEach((ware_item: any, index: number) => {
      if (ware_item.id === item.id) {
        this.selected_ware.splice(index, 1);
      }
    });
  }

  // 点击添加商品按钮
  clickAddWareBtn() {
    this.is_show_add_ware_modal = true;
    this.selected_row_keys = this.selected_ware.map((item: any) => item.id);
  }

  // 关闭添加商品模态窗
  closeModal() {
    this.is_show_add_ware_modal = false;
    this.selected_row_keys = [];
    this.clearFilterValue();
  }

  // 添加商品模态窗确定按钮
  confirmAddWare() {
    const selected_ware_id_arr = this.selected_ware.map((item: any) => item.id);
    const pushData: any = [];
    this.selected_row_keys.forEach((item: any) => {
      this.loaded_data.forEach((items: any) => {
        if (items.id === item && selected_ware_id_arr.indexOf(items.id) === -1) {
          items.is_add = true;
          pushData.push(items);
        }
      });
    });
    this.selected_ware.push(...pushData);
    this.selected_ware.forEach((item: any, index: number) => {
      console.log('index', index);
      this.old_value = item.sort;
      item.sort = index + 1;
      item.count = 1;
      if (!item.is_add) {
        item.is_edit = true;
      }
    });
    this.closeModal();
  }

  // 修改商品数量或排序
  modifyCount(item: any, field: string, value: string) {
    if (!value) {
      this.$message.error(field === 'sort' ? '请输入排序值' : '请输入数量');
      return;
    }
    if (field === 'sort') {
      if (item.sort !== this.old_value && !item.is_add) {
        item.is_edit = true;
      }
    } else {
      if (item.count !== this.old_value && !item.is_add) {
        item.is_edit = true;
      }
    }
    this.edit_index = -1;
    this.selected_ware.sort((a: any, b: any) => {
      return a.sort - b.sort;
    });
  }

  cancelInput(item: any, field: any) {
    this.edit_index = -1;
    item[field] = this.old_value;
  }

  // 点击商品的修改icon
  clickModifyIcon(index: number, value: number, field: string) {
    this.old_value = value;
    this.edit_index = index;
    this.edit_field = field;
  }

  // 添加商品模态窗取消按钮
  closeAddWareModal() {
    this.is_show_add_ware_modal = false;
  }

  // 删除标签
  deleteTage(index: number) {
    this.form.tag.splice(index, 1);
  }

  // 添加标签
  addTag() {
    if (this.form.tag.length >= 4) {
      this.$message.error('最多添加4条标签');
      return;
    }
    if (this.form.tag_name) {
      this.form.tag.push(this.form.tag_name);
    } else {
      this.$message.error('请输入标签名');
      return;
    }
    this.form.tag_name = '';
  }

  // 清空搜索条件
  clearFilterValue() {
    this.filter_form = {
      name: '',
      type: [],
      category: [],
    };
  }

  // 获取样板间绑定的商品
  @changeLoading(['isLoading'])
  async getBindWare(current: number = 1) {
    const url = getUrl(API.get_ware, {
      current,
      limit: 5,
      suit_id: this.$route.query.id,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    res.data.data.forEach((item: any) => {
      item.ware.bind_id = item.id;
      item.ware.count = item.count;
      item.ware.sort = item.sort;
      this.selected_ware.push(item.ware);
    });
  }
  // 点击搜索按钮
  @changeLoading(['is_loading'])
  async clickSearchBtn() {
    console.log(this.filter_form.category);
    await this.getWareList({
      name: this.filter_form.name,
      type: this.filter_form.type.length ? this.filter_form.type[0] : '',
      category_id_first: this.filter_form.category[0],
      category_id_second: this.filter_form.category[1],
      page: 1,
    });
  }

  handleChange2(data: any) {
    this.page = data.current;
  }

  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    await this.getWareList({
      name: this.filter_form.name,
      type: this.filter_form.type.length ? this.filter_form.type[0] : '',
      category_id_first: this.filter_form.category[0],
      category_id_second: this.filter_form.category[1],
      page: data.current,
    });
  }
  // 获取商品列表
  @changeLoading(['is_loading'])
  async getWareList(
    query_params: any = {
      page: 1,
    }
  ) {
    console.log(query_params);
    const url = getUrl(API.query, {
      ...query_params,
      'status': 1,
      'page_size': 10,
      'current_stock[0]': 1,
    });
    const res = await this.$axios.get(url);
    if (res.data.error) {
      this.$message.error(res.data.message);
      return;
    }
    this.ware_data = getWareData(res.data.data.ware_list);
    this.loaded_data.push(...res.data.data.ware_list.data);
    for (let i = 0; i < this.loaded_data.length; i++) {
      this.loaded_data[i] = JSON.stringify(this.loaded_data[i]);
    }
    this.loaded_data = [...new Set(this.loaded_data)];
    for (let i = 0; i < this.loaded_data.length; i++) {
      this.loaded_data[i] = JSON.parse(this.loaded_data[i]);
    }
  }

  // 获取商品分类
  @changeLoading(['is_loading'])
  async getCategoryList() {
    const res = await this.$axios.get(API.category_list);
    if (res.data.status === 200) {
      this.category_list = res.data.data;
      this.category_list.unshift({ id: 0, name: '全部' });
    }
  }

  // 点击提交按钮
  @changeLoading(['is_loading'])
  async submit() {
    if (!this.validateCommit()) {
      return;
    }
    const data = this.form;
    let res;
    if (this.is_edit) {
      const ware_list: any = {
        add: [],
        edit: [],
        remove: [],
      };
      this.selected_ware.forEach((item: any) => {
        if (item.is_add) {
          ware_list.add.push({
            ware_id: item.id,
            count: item.count,
            sort: item.sort,
          });
        }
        if (item.is_edit) {
          ware_list.edit.push({
            id: item.bind_id,
            count: item.count,
            sort: +item.sort,
          });
        }
      });
      if (this.delete_id_arr.length) {
        ware_list.remove = this.delete_id_arr;
      }
      res = await this.$axios.put(`${API.add_set_meal}/${this.$route.query.id}`, {
        id: this.$route.query.id,
        name: data.name,
        price: data.price * 100,
        tag: data.tag.join(','),
        area: data.area,
        specification: data.set_meal,
        description: data.description,
        list_image: data.list_image,
        index_image: data.index_image,
        detail_image: data.detail_image_list,
        ware_list,
      });
    } else {
      const ware_list: any = [];
      this.selected_ware.forEach((item: any) => {
        ware_list.push({
          ware_id: item.id,
          count: item.count,
          sort: item.sort,
        });
      });
      res = await this.$axios.post(API.add_set_meal, {
        name: data.name,
        price: data.price * 100,
        tag: data.tag.join(','),
        area: data.area,
        specification: data.set_meal,
        description: data.description,
        list_image: data.list_image,
        index_image: data.index_image,
        detail_image: data.detail_image_list,
        ware_list,
      });
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$router.go(-1);
    this.$message.success(this.is_edit ? '编辑成功' : '新增成功');
  }

  // 获取详情
  @changeLoading(['is_loading'])
  async getSetMealDetail() {
    const res = await this.$axios.get(`${API.add_set_meal}/${this.$route.query.id}?id=${this.$route.query.id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const data = res.data.data;
    this.form = initFormValue(data);
    this.form.set_meal = data.specification;
    this.form.tag = data.tag ? data.tag.split(',') : [];
    this.form.detail_image_list = data.detail_image;
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getWareList();
    await this.getCategoryList();
    this.is_edit = !!this.$route.query.id;
    if (this.is_edit) {
      await this.getSetMealDetail();
      await this.getBindWare();
    }
  }
}
